import michaelPic from "@/public/images/artists/michael.png";
import { Artist } from "@/types/types";

export const michael = {
  id: "191",
  name: "Michael",
  image: michaelPic,
  description: `Michael's voice has a bright, airy quality with a strong nasal resonance and prominent lisp. His tone sits in a higher register, often carrying a soft rasp or huskiness, and he transitions smoothly into falsetto.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmichael-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Indie", "Folk", "Unprocessed", "Alternative"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 48,
        high: 68,
      },
      sweetSpot: 57,
    },
  },
} as const satisfies Artist;
